export default __webpack_public_path__ + "static/media/element-ht.1dff77c4.svg";